export default __webpack_public_path__ + "static/media/gothenburg_s1.c45440d5.png";